import { EntityType } from '@repo/common/enums/entityType';
import CollectionFooter from './Collection/CollectionFooter';
import DashboardFooter from './Dashboard/DashboardFooter';
import DocumentFooter from './Document/DocumentFooter';
import GlossaryTermFooter from './GlossaryTerm/GlossaryTermFooter';
import MetricFooter from './Metric/MetricFooter';
import QuestionFooter from './Question/QuestionFooter';

interface EntityModalFooterProps {
	type?: EntityType;
}

function EntityModalFooter({ type }: EntityModalFooterProps) {
	return (
		<>
			{type === EntityType.collection && <CollectionFooter />}
			{type === EntityType.glossary && <GlossaryTermFooter />}
			{type === EntityType.metric && <MetricFooter />}
			{type && [EntityType.document, EntityType.query].includes(type) && (
				<DocumentFooter />
			)}
			{type === EntityType.question && <QuestionFooter />}
			{type === EntityType.bi_dashboard && <DashboardFooter />}
		</>
	);
}

export default EntityModalFooter;
